import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#050505] text-white">
      <Header />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid #27272A",
            borderRadius: 0,
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

export default Layout;
